function reverse(array) {
    if (array == null) {
        return array;
    }
    return array.reverse();
}

export { reverse };
